import React, { useCallback } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useNavigate } from "react-router-dom";
import { useInputMode } from "../../utils/hooks/useInputMode";

// ============================================================================
// COMPONENTS
// ============================================================================

var CategoryItem = function (props) {
  var item = props.item;
  var onFocus = props.onFocus;
  var onEnterPress = props.onEnterPress;

  var focusableResult = useFocusable({ onFocus: onFocus, onEnterPress: onEnterPress });
  var focused = focusableResult.focused;
  var ref = focusableResult.ref;
  var focusSelf = focusableResult.focusSelf;

  var inputModeResult = useInputMode();
  var setMouseFocus = inputModeResult.setMouseFocus;
  var handleMouseEnter = useCallback(function () {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return (
    <div className="legacy-category-item-container">
      <div
        ref={ref}
        className={"legacy-category-card" + (focused ? " is-focused" : "")}
        onMouseEnter={handleMouseEnter}
        onClick={onEnterPress}
      >
        <span className="legacy-category-name">{item.name}</span>
        {item.desc && (
          <span className="legacy-category-desc">
            <span>{item.desc}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export var CategoriesSlider = function (props) {
  var categories = props.categories;
  var onFocus = props.onFocus;
  var rowTitle = props.rowTitle;
  var id = props.id;

  var navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="legacy-category-row-title">{rowTitle}</div>
      <div className="legacy-category-scroller">
        <div className="legacy-category-content">
          {categories?.map(function (item) {
            return (
              <CategoryItem
                item={item}
                key={item._id}
                onEnterPress={function () {
                  navigate("/" + item.kind + "/" + item.slug);
                }}
                onFocus={onFocus}
              />
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};
